import btFacebook from '@/domain/icon/svg/button/bt-facebook'
import btTwitter from "@/domain/icon/svg/button/bt-twitter";
import btTelegram from "@/domain/icon/svg/button/bt-telegram";
import btWhatsapp from "@/domain/icon/svg/button/bt-whatsapp";
import btCopy from "@/domain/icon/svg/button/bt-copy";
import btEmail from "@/domain/icon/svg/button/bt-email";

export const _icons = {
    btFacebook,
    btTwitter,
    btTelegram,
    btWhatsapp,
    btCopy,
    btEmail,
}